
<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<form [formGroup]="form" (ngSubmit)="onSaveAction()" class="k-form-inline">

  <div class="k-form-field">
    <label class="form-label col-4 k-label" for="name">Name</label>
    <div class="col-7">
      <input appAutoFocus type="text" id="name" formControlName="name" class="form-control">
      <div *ngIf="name?.invalid" class="alert alert-danger">
        <div *ngIf="name?.errors?.['required']">Name is required.</div>
      </div>
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-4 k-label" for="can_select">Organisation Selectable</label>
    <div class="col-7">
      <kendo-checkbox id="can_select" formControlName="can_select" size="large"></kendo-checkbox>
    </div>
  </div>
  <div class="alert alert-danger" *ngIf="form.errors?.['duplicateRole']">
    That role already exists.
  </div>
</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="form.invalid">
    Save
  </button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>
